<template>
    <div class="accountRecoveryWrapper">
        <v-card class="accountRecoveryCard elevation-10" shaped>
            <v-btn
                icon
                class="white--text ma-3"
                @click="$router.go(-1)"
            >
                <v-icon>{{ mdiArrowLeft }}</v-icon>
            </v-btn>
            <v-card-text>
                <v-alert
                    v-model="error.status"
                    dismissible
                    class="text-center"
                    transition="scale-transition"
                    style="position: absolute; z-index: 2; left: 0; right: 0; top: calc(20% - 10px); margin: 0 10px; border-radius: 16px;"
                    :type="error.color"
                >
                    {{ error.message }}
                </v-alert>
                <div class="accountContentWrapper">
                    <div class="forgotPassSend">
                        <img src="../../../assets/hmi-cross.svg" alt="hmiLogo">
                    </div>
                    <div
                        class="displayAccountRecovery d-flex justify-space-around align-center"
                    >
                        <div class="account">
                            <h3>Member Code:</h3>
                            <h2>{{ userMembn || "&nbsp;" }}</h2>
                        </div>
                    </div>
                    <div class="fieldWrapper text-center">
                        <h4>Enter the email address that you registered with your account:</h4>
                        <v-form
                            ref="form"
                            v-model="valid"
                            @submit.prevent="validateEmail()"
                        >
                            <v-text-field
                                ref="email"
                                v-model="email"
                                clearable
                                :rules="emailRule"
                                label="Enter email address"
                                color="green accent-4"
                                autocomplete="nope"
                            />
                            <v-btn
                                type="submit"
                                color="green accent-4 white--text"
                                class="my-3 btnSendLink"
                                small
                                :disabled="!valid || btn_disabled"
                            >
                                <h4>Send</h4>
                            </v-btn>
                        </v-form>
                    </div>
                </div>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { mdiArrowLeft } from '@mdi/js'
import { mapActions, mapGetters } from 'vuex'
export default {
    props: ['userMembn', 'userName', 'userStatus'],
    data: () => ({
        mdiArrowLeft,
        error: {
            status: false,
            color: 'error',
            message: ''
        },
        valid: true,
        email: '',
        emailRule: [
            (v) => !!v || 'Email is required',
            // (v) => /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(v) || 'Invalid Email',
            (v) => /^[a-zA-Z0-9]+([._%-][a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/.test(v) || 'Invalid Email'
        ],
        btn_disabled: false
    }),
    computed: {
        ...mapGetters(['getErrorPrompt', 'isRecoveryPassLinkSent'])
    },
    watch: {
        getErrorPrompt(newVal) {
            if (newVal) {
                this.error = {
                    color: 'error',
                    status: true,
                    message: newVal
                }
                setTimeout(()=>{
                    this.error.status = false
                }, 4000)
            }
        },
        isRecoveryPassLinkSent(newVal) {
            if (newVal) {
                this.error = {
                    color: 'success',
                    status: true,
                    message: newVal
                }
                setTimeout(()=>{
                    this.error.status = false
                }, 4000)
            }
        }
    },
    methods: {
        ...mapActions(['recoveryLink']),
        async validateEmail() {
            if (this.$refs.form.validate()) {
                await this.recoveryLink({ MEMBN: this.userMembn, EMAIL: this.email })
                const isMailSent = this.isRecoveryPassLinkSent
                if (isMailSent) {
                    this.btn_disabled = true
                } else {
                    this.btn_disabled = false
                }
            }
        }
    }
}
</script>

<style scoped>
.accountRecoveryWrapper {
  width: 100%;
}
.forgotPassSend {
  width: 10%;
  margin: 15px auto;
}
.forgotPassSend img {
  width: 100%;
}
.accountRecoveryCard {
  width: 50%;
  margin: auto;
  background-image: url("../../../assets/mail-bg-wrapper.webp");
  background-size: cover;
  background-position: left;
}
.accountContentWrapper {
  width: 70%;
  margin: auto;
}
.displayAccountRecovery {
  margin: 30px 0px;
}
.account {
  color: black;
}
.account h2 {
  padding: 10px;
  font-weight: normal;
}
.account h3 {
  font-size: 13px;
  font-weight: normal;
}
.fieldWrapper {
  width: 70%;
  margin: 15px auto;
  color: black;
}
.btnSendLink {
  width: 60%;
}
@media (max-width: 599px) {
  .accountRecoveryCard {
    width: 90%;
  }
  .displayAccountRecovery {
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-direction: column;
  }
  .accountContentWrapper {
    width: 100%;
  }
  .account {
    text-align: center;
  }
  .fieldWrapper {
    width: 100%;
  }
  .btnSendLink {
    width: 90%;
  }
}
@media (min-width: 599px) and (max-width: 960px) {
.forgotPassSend {
  width: 20%;
  margin: 15px auto;
}
.forgotPassSend img {
  width: 100%;
}
  .accountRecoveryCard {
    width: 50%;
  }
  .displayAccountRecovery {
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-direction: column;
  }
  .accountContentWrapper {
    width: 90%;
  }
  .account {
    text-align: center;
  }
  .fieldWrapper {
    width: 70%;
  }
  .btnSendLink {
    width: 90%;
  }
}
@media (min-width: 960px) {
  .accountRecoveryCard {
    width: 40%;
  }
  .displayAccountRecovery {
    width: 100%;
  }
  .accountContentWrapper {
    width: 90%;
    height: 50%;
  }
  .account {
    text-align: center;
  }
  .fieldWrapper {
    width: 70%;
  }
  .btnSendLink {
    width: 90%;
  }
}
@media (min-width: 1264px) and (max-width: 1904px) {
  .accountRecoveryCard {
  }
}
</style>
